module.exports = __webpack_public_path__ + "img/20_123.27298973.png";